import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path fill="#00ADEF"
          d="M0,4.50981818 L12.9770909,2.74247273 L12.9827636,15.2599273 L0.0118545455,15.3337927 L0,4.50981818 Z M12.9709091,16.7021818 L12.9809818,29.2305455 L0.0100727273,27.4472364 L0.00934545455,16.6181455 L12.9709091,16.7021818 Z M14.5440364,2.51127273 L31.7505818,7.10542736e-15 L31.7505818,15.1007273 L14.5440364,15.2373273 L14.5440364,2.51127273 Z M31.7545818,16.82 L31.7505455,31.8527273 L14.544,29.4242182 L14.5198909,16.7918545 L31.7545818,16.82 Z"/>
  </svg>
);
